const { omit } = require("underscore");

define((require) => {
    "use strict";

    const Backbone                  = require("backbone");
    const ImprovedView              = require("editor/zbone/ImprovedView");
    const ExperienceURLProvider     = require("ui/experience/ExperienceURLProvider");
    const EditorMoreMenu            = require("ui/editor/editorMoreMenu/EditorMoreMenuView");
    const EditorEvents              = require("shared/services/EditorEvents");
    const PushPublishButtonView     = require("ui/editor/editorMoreMenu/PushPublishButtonView");
    const ToggleEmailMode           = require("ui/editor/editorMoreMenu/ToggleEmailModeView");
    const SendTestEmailButtonView   = require("ui/editor/email/SendTestEmailButtonView");
    const LoggedInUserState         = require("shared/ui/user/LoggedInUserState");
    const Syncer                    = require("shared/services/sync/Syncer");
    const template                  = require("ui/editor/EditorPreviewMenu.tpl");
    const Storage                   = require("shared/services/Storage");
    const Configuration              = require("shared/services/Configuration");
    const SystemMessages            = require("editor/services/SystemMessages");

    const CONTENT_CONTROL_URL = Configuration.contentControlUrl;

    /**
     * @cfg {EditorViewModel} model
     *
     * @class EditorPreviewMenu
     */
    return ImprovedView.extend({

        className: "editor-preview-menu",

        template: template,

        /**
         * @private @type {Boolean}
         * True if the experience is currently being synced (saved).
         */
        _syncing: false,

        _isEmailInCreatorEnabled: false,

        _isNewDashboardExperience: false,

        ui: {
            previewBtn: ".preview-btn",
            previewPublishBtn: ".preview-publish-btn"
        },

        events: {
            "click @ui.previewBtn": "_showPreview",
            "click @ui.previewPublishBtn": "_showPreviewInContentControl"
        },

        regions: {
            pushPublishButtonRegion: ".push-publish-btn-region",
            toggleEmailModeRegion: ".toggle-email-mode-region",
            sendTestEmailButtonRegion: ".send-test-email-btn-region",
            editorMoreMenu: ".editor-more-menu"
        },

        initialize() {
            this._isEmailInCreatorEnabled = LoggedInUserState.get("companySettings").get("isCreatorInEmailEnabled");
            this._isNewDashboardExperience = Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP);
            this._syncEmailMode();
            this.listenTo(this.model, "sync:state", (state, method) => {
                if (method !== "destroy") {
                    this._syncing = state === Syncer.State.Pending || state === Syncer.State.Syncing;
                    this.ui.previewBtn.toggleClass("disabled", this._syncing);
                }
            });
        },

        templateHelpers: function() {
            return {
                isEmailInCreatorEnabled: this._isEmailInCreatorEnabled,
                isNewDashboardExperience: this._isNewDashboardExperience
            };
        },

        onShow: function() {
            const isGroup = this.options.group;

            this.pushPublishButtonRegion.show(new PushPublishButtonView({
                model: this.model,
                project: this.options.project,
                hidePublish: this._isNewDashboardExperience || !!isGroup,
                hidePushBtn: this._isNewDashboardExperience
            }));

            this.toggleEmailModeRegion.show(new ToggleEmailMode({
                model: this.model,
                group: this.options.group
            }));

            this.editorMoreMenu.show(new EditorMoreMenu({
                model: this.options.viewModel,
                experience: this.model
            }));

            if (this._isEmailInCreatorEnabled) {
                this.sendTestEmailButtonRegion.show(new SendTestEmailButtonView({
                    viewModel: this.options.viewModel,
                    experienceModel: this.model
                }));
            }
        },

        _syncEmailMode: function() {
            if (!this._isEmailInCreatorEnabled && this.model.get("emailModeEnabled")) {
                this.model.set({emailModeEnabled: false});
            }
        },

        _showPreview: function() {
            if (!this._syncing) {
                const experience = this.model;
                const experienceId = experience.get("id");
                const sceneNumber = this.model.get("sceneNumber");
                const experiencePreviewURL = ExperienceURLProvider.provide(
                    experienceId,
                    ExperienceURLProvider.ACTION.PREVIEW,
                    sceneNumber,
                    this.viewScope.viewModel.get("currentLayer").value
                );

                Backbone.history.navigate(experiencePreviewURL, true);
                EditorEvents.trigger(EditorEvents.constants.OPEN_EXPERIENCE_PREVIEW, {
                    experienceId: experienceId,
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: sceneNumber,
                    projectId: this.options.project && this.options.project.get("id"),
                    triggerOrigin: "EditorPreviewButton"
                });
            }
        },

        _showPreviewInContentControl: function() {
            const experience = this.model;
            if (Object.keys(experience.changed).length === 1) {
                experience.set({ state: Syncer.State.Synced });
                const query = new URLSearchParams(window.location.search);
                        const containerId = query.get("containerId");
                        const collectionId = query.get("collectionId");
                        const experienceId = experience.get("id");
                        window.location.href = `${CONTENT_CONTROL_URL}?containerId=${containerId}&collectionId=${collectionId}&experienceId=${experienceId}#preview`;
            }
            else {
                // Set state and trigger a save
                experience.set({ state: Syncer.State.Pending });
                experience.trigger("sync:state");

                // here state variable indicates currentstate ie.- Syncer.State.current(this.model);
                this.listenTo(experience, "sync:state", (state) => {
                    // once experienced is saved redirect to Content Control Preview Page
                    if (state == Syncer.State.Synced) {
                        const query = new URLSearchParams(window.location.search);
                        const containerId = query.get("containerId");
                        const collectionId = query.get("collectionId");
                        const experienceId = experience.get("id");
                        window.location.href = `${CONTENT_CONTROL_URL}?containerId=${containerId}&collectionId=${collectionId}&experienceId=${experienceId}#preview`;
                    }
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/EditorPreviewMenu.js